export const LONG_PRICE_CHARACTER_LIMIT = 8;
export const LONG_PRICE_MOBILE_CHARACTER_LIMIT = 10;

type Props = {
  price: string | undefined;
  isMobile: boolean;
};

export const getHasLongPrice = ({ price, isMobile }: Props) => {
  const limit = isMobile ? LONG_PRICE_MOBILE_CHARACTER_LIMIT : LONG_PRICE_CHARACTER_LIMIT;

  return !!(price && price.length >= limit);
};
